import { render } from "./EventWinnerPage.vue?vue&type=template&id=5086b844&scoped=true"
import script from "./EventWinnerPage.vue?vue&type=script&lang=js"
export * from "./EventWinnerPage.vue?vue&type=script&lang=js"

import "./EventWinnerPage.vue?vue&type=style&index=0&id=5086b844&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5086b844"]])

export default __exports__